import { useState, useCallback } from 'react';
import ServiceCollection from 'src/services/ServiceCollection';
import { fetchAccounts } from 'src/utils/FramesUtils';
import { FramesSearchType } from 'src/models/Frames';

export const useFramesAccounts = (services: ServiceCollection) => {
  const [framesAccounts, setFramesAccounts] = useState<string[]>([]);
  const [loadingFramesAccounts, setLoadingFramesAccounts] = useState(false);
  const [fetchFramesAccountsErrorMessage, setFetchFramesAccountsErrorMessage] = useState('');

  const getFramesAccounts = useCallback(
    async (accountNum: string = '', searchType: FramesSearchType) => {
      // If frames accounts are already loaded from React context, just return.
      if (accountNum.length < 2) {
        return;
      }
      fetchAccounts(
        services.framesService,
        setFramesAccounts,
        setLoadingFramesAccounts,
        setFetchFramesAccountsErrorMessage,
        accountNum!,
        searchType,
      );
    },
    [framesAccounts],
  );
  return {
    framesAccounts,
    loadingFramesAccounts,
    fetchFramesAccountsErrorMessage,
    getFramesAccounts,
  };
};
